<template>
  <a-spin :spinning="spinning">
    <a-card>
      <div class="search">
        <a-form layout="horizontal" :model="form">
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item
                label="经办人"
                :labelCol="{ span: 6 }"
                :wrapperCol="{ span: 15 }"
              >
                <a-input
                  placeholder="请输入"
                  v-model="form.goodsName"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item
                label="入库日期"
                :labelCol="{ span: 4 }"
                :wrapperCol="{ span: 15 }"
              >
                <a-date-picker
                  v-model="form.deliverDate"
                  format="YYYY-MM-DD"
                  placeholder="请选择日期"
                  @change="changeDate"
                />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-button type="primary" @click="search(1)">查询</a-button>
              <div class="space"></div>
              <a-button type="default" @click="reset()">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table">
        <div class="add">
          <a-button type="primary" @click="handleAdd">
            <a-icon type="plus" />新增</a-button
          >
        </div>
        <standard-table
          :columns="columns"
          :dataSource="listData"
          :pagination="pagination"
          @change="onChange"
          :loading="loading"
        >
          <div slot="status" slot-scope="{ record }">
            <span>
              {{
                record.status == "0"
                  ? "审核中"
                  : record.status == "1"
                  ? "审核通过"
                  : record.status == "2"
                  ? "审核拒绝"
                  : "--"
              }}</span
            >
          </div>
          <div slot="operate" slot-scope="record">
            <a-popconfirm
              ok-text="是"
              cancel-text="否"
              @confirm="popConfirm(record)"
              @cancel="popCancel"
              :disabled="record.record.status !== 0"
            >
              <template slot="title">
                <div>操作审核？</div>
                <div class="popRadio">
                  <a-radio-group name="radioGroup" v-model="popValue">
                    <a-radio :value="1"> 审核通过 </a-radio>
                    <a-radio :value="2"> 审核拒绝 </a-radio>
                  </a-radio-group>
                </div>
              </template>
              <a-button
                size="small"
                type="danger"
                v-show="level <= 3"
                :disabled="record.record.status !== 0"
                @click.prevent="examine(record)"
              >
                审核
              </a-button>
            </a-popconfirm>
            <a @click="handleReceiveUpdate(record)" v-show="level > 3">修改</a
            >&nbsp;
            <a @click="handleReceiveDelete(record)" v-show="level > 3"> 删除 </a
            >&nbsp;
          </div>
        </standard-table>
      </div>
      <div class="modal" v-show="visible">
        <a-modal
          v-model="visible"
          :title="modalTitle"
          @ok="handleOk"
          cancelText="取消"
          okText="保存"
          :key="key"
          width="60%"
        >
          <a-spin :spinning="spinning2">
            <a-form-model ref="addForm" :model="addForm" v-bind="layout">
              <div class="modelItem">
                <a-form-model-item has-feedback label="发货人" prop="username">
                  <a-input v-model="addForm.deliverer" />
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  label="发货日期"
                  prop="deliverDate"
                >
                  <a-date-picker
                    v-model="addForm.deliverDate"
                    format="YYYY-MM-DD"
                    placeholder="请选择日期"
                    @change="changeDate2"
                  />
                </a-form-model-item>
                <a-form-model-item has-feedback label="车牌号" prop="username">
                  <a-input v-model="addForm.licenseNum" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="发货地" prop="username">
                  <a-input v-model="addForm.sendAddr" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="收货地" prop="username">
                  <a-input v-model="addForm.receiveAddr" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="品名" prop="username">
                  <a-input v-model="addForm.goodsName" />
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  label="采购单价"
                  prop="username"
                >
                  <a-input
                    v-model="addForm.purchaseUnitPrice"
                    @blur="getTwoDot('purchaseUnitPrice')"
                  />
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  label="采购金额"
                  prop="username"
                >
                  <a-input
                    v-model="addForm.purchaseMoney"
                    @blur="getTwoDot('purchaseMoney')"
                  />
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  label="加油(升)"
                  prop="username"
                >
                  <a-input v-model="addForm.oil" @blur="getTwoDot('oil')" />
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  label="出货重量（吨）"
                  prop="username"
                >
                  <a-input
                    v-model="addForm.sendGoodsWeight"
                    @blur="getTwoDot('sendGoodsWeight')"
                  />
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  label="收货重量（吨）"
                  prop="username"
                >
                  <a-input
                    v-model="addForm.receiveGoodsWeight"
                    @blur="getTwoDot('receiveGoodsWeight')"
                  />
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  label="司机领款金额"
                  prop="username"
                >
                  <a-input
                    v-model="addForm.driverReceiveMoney"
                    @blur="getTwoDot('driverReceiveMoney')"
                  />
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  label="司机领款事由"
                  prop="username"
                >
                  <a-input v-model="addForm.driverReceiveDesc" />
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  label="司机领款付款方式"
                  prop="username"
                >
                  <a-select v-model="addForm.driverReceiveType">
                    <a-select-option value="微信">微信</a-select-option>
                    <a-select-option value="支付宝">支付宝</a-select-option>
                    <a-select-option value="银联">银联</a-select-option>
                    <a-select-option value="现金">现金</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  label="司机收运费款"
                  prop="username"
                >
                  <a-input
                    v-model="addForm.freightPayment"
                    @blur="getTwoDot('freightPayment')"
                  />
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  label="司机报销金额"
                  prop="username"
                >
                  <a-input
                    v-model="addForm.applyMoney"
                    @blur="getTwoDot('applyMoney')"
                  />
                </a-form-model-item>
                <a-form-model-item
                  has-feedback
                  label="司机报销事由"
                  prop="username"
                >
                  <a-input v-model="addForm.applyMoneyDesc" />
                </a-form-model-item>

                <a-form-model-item
                  has-feedback
                  label="报销凭证"
                  prop="username"
                >
                  <!-- <a-input v-model="addForm.applyVoucherUrl" /> -->
                  <a-upload
                    name="file"
                    :customRequest="customRequest"
                    :loading="uploading"
                    :handleChange="handleChange"
                    size="500px"
                  >
                    <a-button> <a-icon type="upload" /> 上传凭证 </a-button>
                  </a-upload>
                </a-form-model-item>
              </div>
            </a-form-model>
          </a-spin>
        </a-modal>
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import StandardTable from "@/components/StandardTable";
import moment from "moment";
import {
  oilinList,
  oilinSave,
  oilinUpdate,
  oilinDelete,
} from "@/api/modules/standingBookManagement.js";
import axios from "axios";
// import { uploadVoucher } from "@/api/api.js";
export default {
  name: "oilStorageManagement",
  data() {
    return {
      form: {
        sendAddr: "",
        receiveAddr: "",
        goodsName: "",
        deliverDate: "",
      },
      popValue: 1,
      addForm: {
        deliverer: "",
        deliverDate: "",
        licenseNum: "",
        sendAddr: "",
        receiveAddr: "",
        goodsName: "",
        sendGoodsWeight: "", //出货重量（吨）
        receiveGoodsWeight: "", //收货重量（吨）
        purchaseUnitPrice: "", //采购单价
        purchaseMoney: "", //采购金额
        freightPayment: "", //司机收运费款
        oil: "", //加油(升)
        driverReceiveMoney: "", //司机领款金额
        driverReceiveDesc: "",
        driverReceiveType: "",
        applyMoney: "", //司机报销金额
        applyMoneyDesc: "",
        applyVoucherUrl: "",
      },
      applyVoucherUrlArr: [],
      headers: {
        "Content-Type": "multipart/form-data",
        Token: sessionStorage.getItem("Token") || localStorage.getItem("Token"),
      },
      pagination: {
        total: 0,
        pageSize: 10, //每页中显示10条数据
        current: 1,
        showTotal: (total) => `共 ${total} 条`, //分页中显示总的数据
      },
      layout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 12 },
      },
      columns: [
        {
          title: "发货人",
          dataIndex: "deliverer",
          align: "center",
        },
        {
          title: "车牌号",
          dataIndex: "licenseNum",
          align: "center",
        },
        {
          title: "发货日期",
          dataIndex: "deliverDate",
          align: "center",
        },
        {
          title: "发货地",
          dataIndex: "sendAddr",
          align: "center",
        },
        {
          title: "收货地",
          dataIndex: "receiveAddr",
          align: "center",
        },
        {
          title: "品名",
          dataIndex: "goodsName",
          align: "center",
        },
        {
          title: "加油",
          dataIndex: "oil",
          align: "center",
        },
        {
          title: "状态",
          dataIndex: "status",
          align: "center",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          align: "center",
        },
        {
          title: "操作",
          dataIndex: "operate",
          align: "center",
          scopedSlots: { customRender: "operate" },
        },
      ],
      listData: null,
      spinning: false,
      uploading: false,
      spinning2: false,
      loading: false,
      visible: false,
      level: "",
      key: "",
      modalTitle: "",
    };
  },
  created() {
    this.search(1);
    this.level = JSON.parse(localStorage.getItem("jwt")).level;
    console.log(this.level);
  },
  components: {
    StandardTable,
  },
  methods: {
    moment,
    //查询用户列表
    search(val) {
      console.log("111111111111", val);
      let params = {
        sendAddr: this.form.sendAddr,
        receiveAddr: this.form.receiveAddr,
        goodsName: this.form.goodsName,
        deliverDate: this.form.deliverDate,
      };
      this.loading = true;
      oilinList(params, val, this.pagination.pageSize).then((res) => {
        if (res.code == "0000") {
          this.listData = res.data.list.map((item) => {
            for (let key in item) {
              if (item[key] === null || item[key] === "") {
                item[key] = "--";
              }
            }
            return item;
          });
          this.pagination.total = res.data.totalCount;
        } else {
          this.$message.warn(res.msg);
        }
        this.loading = false;
      });
    },
    reset() {
      this.form = {
        sendAddr: "",
        receiveAddr: "",
        goodsName: "",
        deliverDate: "",
      };
    },
    getTwoDot(key) {
      this.addForm[key] = Number(this.addForm[key]).toFixed(2);
    },
    //选择日期
    changeDate(val) {
      this.form.deliverDate = this.$moment(val).format("YYYY-MM-DD");
    },
    changeDate2(val) {
      this.addForm.deliverDate = this.$moment(val).format("YYYY-MM-DD");
    },
    onChange(val) {
      this.pagination.current = val.current;
      this.search(this.pagination.current);
    },
    customRequest(options) {
      console.log("1111", options);
      let params = new FormData();
      params.append("file", options.file);
      //添加请求头
      let _this = this;
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Token:
            sessionStorage.getItem("Token") || localStorage.getItem("Token"),
        },
      };
      this.uploading = true;
      axios
        .post(
          `${process.env.VUE_APP_REQUEST_URL}/upload/voucher`,
          params,
          config
        )
        .then((res) => {
          if (res.data.code == "0000") {
            this.$message.success("上传成功");
            this.applyVoucherUrlArr.push(res.data.data);
          } else {
            this.$message.warn(res.data.msg);
          }
          options.onSuccess(res, options.file);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    handleChange(info) {
      if (info.file.status === "uploading") {
        this.uploading = true;
        return;
      }
      if (info.file.status === "done") {
        this.uploading = false;
      }
    },
    handleAdd() {
      this.key++;
      this.modalTitle = "新增";
      for (let key in this.addForm) {
        if (this.addForm[key] !== "") {
          this.addForm[key] = "";
        }
      }
      this.visible = true;
    },
    handleOk() {
      if (this.modalTitle == "新增") {
        let params = Object.assign(this.addForm);
        if (this.applyVoucherUrlArr.length > 1) {
          params.applyVoucherUrl = this.applyVoucherUrlArr.join(",");
        } else {
          params.applyVoucherUrl = this.applyVoucherUrlArr[0];
        }
        (params.sendGoodsWeight = Number(this.addForm.sendGoodsWeight)), //出货重量（吨）
          (params.receiveGoodsWeight = Number(this.addForm.receiveGoodsWeight)), //收货重量（吨）
          (params.purchaseUnitPrice = Number(this.addForm.purchaseUnitPrice)), //采购单价
          (params.purchaseMoney = Number(this.addForm.purchaseMoney)), //采购金额
          (params.freightPayment = Number(this.addForm.freightPayment)), //司机收运费款
          (params.oil = Number(this.addForm.oil)), //加油(升)
          (params.driverReceiveMoney = Number(this.addForm.driverReceiveMoney)), //司机领款金额applyMoney
          (params.applyMoney = Number(this.addForm.applyMoney));
        this.spinning2 = true;
        oilinSave("", params).then((res) => {
          this.spinning2 = false;
          if (res.code == "0000") {
            this.$message.success(res.msg);
            this.search(1);
            this.visible = false;
          } else {
            this.$message.warn(res.msg);
          }
        });
      } else if (this.modalTitle == "修改") {
        let params = Object.assign(this.addForm);
        if (this.applyVoucherUrlArr.length > 1) {
          params.applyVoucherUrl = this.applyVoucherUrlArr.join(",");
        } else {
          params.applyVoucherUrl = this.applyVoucherUrlArr[0];
        }
        (params.sendGoodsWeight = Number(this.addForm.sendGoodsWeight)), //出货重量（吨）
          (params.receiveGoodsWeight = Number(this.addForm.receiveGoodsWeight)), //收货重量（吨）
          (params.purchaseUnitPrice = Number(this.addForm.purchaseUnitPrice)), //采购单价
          (params.purchaseMoney = Number(this.addForm.purchaseMoney)), //采购金额
          (params.freightPayment = Number(this.addForm.freightPayment)), //司机收运费款
          (params.oil = Number(this.addForm.oil)), //加油(升)
          (params.driverReceiveMoney = Number(this.addForm.driverReceiveMoney)), //司机领款金额applyMoney
          (params.applyMoney = Number(this.addForm.applyMoney));
        this.spinning2 = true;
        oilinUpdate("", params).then((res) => {
          this.spinning2 = false;
          if (res.code == "0000") {
            this.$message.success(res.msg);
            this.search(1);
            this.visible = false;
          } else {
            this.$message.warn(res.msg);
          }
        });
      }
    },
    examine(record) {
      if (record.record.status !== 0) {
        return false;
      }
    },
    handleReceiveUpdate(record) {
      this.key++;
      this.modalTitle = "修改";
      this.addForm = Object.assign(record.record);
      this.visible = true;
    },
    oilinDelete(record) {
      console.log(record);
      if (record.record.status < 2) {
        this.$message.warn("正在审核中，无法删除");
      }
      if (record.record.status === 2 && this.level > 3) {
        let that = this;
        this.$confirm({
          title: "操作提示",
          content: "是否删除该记录信息？",
          okText: "确定",
          cancelText: "取消",
          onOk() {
            let id = record.record.id;
            that.loading = true;
            driverbookDelete(id).then((res) => {
              if (res.code == "0000") {
                that.search(that.pagination.current);
                that.$message.success(res.msg);
              } else {
                that.$message.warn(res.msg);
              }
              that.loading = false;
            });
          },
        });
      }
    },
    popConfirm(record) {
      console.log(record);
      let params = {
        id: record.record.id,
        status: this.popValue,
      };
      this.spinning = true;
      driverbookExamine("", params).then((res) => {
        this.spinning = false;
        if (res.code == "0000") {
          this.$message.success("操作成功");
          this.a;
        }
        this.search(this.pagination.current);
        this.popValue = 1;
        console.log(res);
      });
    },
    popCancel() {},
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-calendar-picker {
  width: 100%;
}
.space {
  display: inline-block;
  margin: 0 5px;
}
.add {
  text-align: left;
  margin-bottom: 10px;
}
.modelItem {
  /deep/ .ant-form-item {
    width: 50%;
    display: inline-block;
    /deep/ .ant-form-item-control {
      width: 200%;
    }
  }
}
.popRadio {
  /deep/.ant-radio-group {
    display: flex !important;
    margin-top: 10px;
  }
}
</style>